import { AnalyticsPlugins } from '@/modules/analytics';
import { getBaseSWRConfig } from '@/modules/order-form/utils/get-base-swr-config.config';
import { CreateToastFnReturn } from '@chakra-ui/react';
import { AnalyticsInstance } from 'analytics';
import { AxiosError } from 'axios';
import { SWRConfiguration } from 'swr';
import { buildError } from './build-error';

const defaultToastParams = {
  isClosable: true,
  duration: 10000,
};

export const getSWRConfig = (toast: CreateToastFnReturn, analytics: AnalyticsInstance): SWRConfiguration => {
  return {
    ...getBaseSWRConfig(),
    onError: (error: AxiosError) => {
      console.error(error);

      const builtError = buildError(error);

      if (!toast.isActive(builtError.id)) {
        toast({
          id: builtError.id,
          title: builtError.errorMessage,
          status: 'error',
          ...defaultToastParams,
        });
      }

      const analyticsPlugins = analytics.plugins as unknown as AnalyticsPlugins;

      if (analyticsPlugins?.datadogRum?.error) {
        analyticsPlugins.datadogRum.error(error);
      }
    },
  };
};
